import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BYPASS_LOADER } from '@core/loading/loader-context.token';
import { environment } from 'src/environments/environment';
import { BaseUrl } from './auth-interface';

type HttpMethod = 'get' | 'post' | 'put' | 'delete';

@Injectable({ providedIn: 'root' })
export class ApiService {


  constructor(private http: HttpClient) { }

  private withBypassContext(options: any = {}): any {
    return {
      ...options,
      context: (options.context ?? new HttpContext()).set(BYPASS_LOADER, true),
    };
  }

  get<T>(url: string, options: any = {}, baseUrl: BaseUrl = BaseUrl.Base): Observable<HttpEvent<T>> {
    return this.http.get<T>(environment[baseUrl] + url, options);
  }

  post<T>(url: string, body: any = undefined, options: any = {}, baseUrl: BaseUrl = BaseUrl.Base): Observable<HttpEvent<T>> {
    return this.http.post<T>(environment[baseUrl] + url, body, options);
  }

  put<T>(url: string, body: any, options: any = {}, baseUrl: BaseUrl = BaseUrl.Base): Observable<HttpEvent<T>> {
    return this.http.put<T>(environment[baseUrl] + url, body, options);
  }

  delete<T>(url: string, options: any = {}, baseUrl: BaseUrl = BaseUrl.Base): Observable<HttpEvent<T>> {
    return this.http.delete<T>(environment[baseUrl] + url, options);
  }

  skipLoader<T>(
    method: HttpMethod,
    url: string,
    bodyOrOptions?: any,
    maybeOptions?: any,
    baseUrl: BaseUrl = BaseUrl.Base
  ): Observable<HttpEvent<T>> {
    switch (method) {
      case 'get':
      case 'delete':
        return this[method]<T>(url, this.withBypassContext(bodyOrOptions), baseUrl);
      case 'post':
      case 'put':
        return this[method]<T>(url, bodyOrOptions, this.withBypassContext(maybeOptions), baseUrl);
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }
  }
}
